import { Box, Button, Grid } from "@material-ui/core";
import CountTextField from "@saleor/components/CountTextField";
import DatePicker from "@saleor/components/DatePicker";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextField from "@saleor/components/SingleTextField";
import classNames from "classnames";
import moment from "moment";
import React, { ChangeEvent, FC, memo, useContext } from "react";
import { useIntl } from "react-intl";

import CommentCustomerIcon from "../../../../../assets/images/comment-customer.svg";
import NewsPaperIcon from "../../../../../assets/images/newspaper.svg";
import { CustomerContext } from "../CollectionFormSubmit";
import Shipping from "./Shipping";
import useStyles from "./styles";

interface IAdditionalInfoRender {
  id: number;
  label: string;
  name: string;
  placeholder: string;
  icon?: React.ReactNode;
}

const CustomerData: FC = memo(() => {
  const { formik, customerData } = useContext(CustomerContext);
  const classes = useStyles();
  const intl = useIntl();

  const additionalInfoRender: IAdditionalInfoRender[] = [
    {
      id: 4,
      label: intl.formatMessage({
        defaultMessage: "ข้อมูลเพิ่มเติมสำหรับจัดส่ง",
        description: "label"
      }),
      name: "internalCommentsToLogistic",
      placeholder: "พิมพ์ที่นี่...",
      icon: <img src={CommentCustomerIcon} alt="" />
    }
  ];

  const handleChangeDatepicker = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    formik.setFieldValue("requestDeliveryDate", value);
    if (value) {
      const today = moment();

      if (today.isAfter(value)) {
        formik.setTouched({ ...formik.touched, requestDeliveryDate: true });
      } else {
        formik.setTouched({ ...formik.touched, requestDeliveryDate: false });
      }
    }
  };

  const handlePODate = e => {
    formik.handleChange(e);
  };

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <img src={NewsPaperIcon} alt="" style={{ marginRight: "2.0rem" }} />
        <div>
          <MyTypography variant="body3" className={classes.titleHeader}>
            เลขที่ Contract
          </MyTypography>
          <MyTypography variant="h6" style={{ color: "#ffffff" }}>
            {customerData?.contract?.code}
          </MyTypography>
        </div>
      </div>
      <div className={classes.wrapContent}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <div className={classes.customerBox}>
              <div className={classes.boxInfo}>
                <MyTypography variant="body1" className={classes.company}>
                  {`${customerData?.contract?.soldTo?.code} - ${customerData?.contract?.soldTo?.name}`}
                </MyTypography>
                <MyTypography
                  style={{
                    padding: "0rem 1.2rem 1.6rem 1.2rem"
                  }}
                  variant={"body3"}
                >
                  {customerData?.soldToAddress}
                </MyTypography>
              </div>
              <div className={classNames(classes.boxInfo, classes.project)}>
                <MyTypography variant="captionBold">
                  {intl.formatMessage({
                    defaultMessage: "ชื่อโครงการ",
                    description: "label"
                  })}
                </MyTypography>
                <MyTypography variant="body3" className={classes.labelAddress}>
                  {customerData?.contract?.projectName || ""}
                </MyTypography>
              </div>
            </div>
            <div className={classes.customerInput}>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <div className={classes.inputField}>
                    <MyTypography
                      variant="subtitle3"
                      className={classes.inputLabel}
                    >
                      {intl.formatMessage({
                        defaultMessage: "เลขที่ใบสั่งซื้อ",
                        description: "label"
                      })}
                      <span className={classes.required}>*</span>
                    </MyTypography>
                    <SingleTextField
                      id="orderNo"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.orderNo}
                      name={"orderNo"}
                      placeholder={"ระบุเลขที่ใบสั่งซื้อ"}
                      error={formik.errors.orderNo ? true : false}
                      className={classes.textFieldNoLabel}
                      maxLengthProps={10}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <MyTypography
                    variant="subtitle3"
                    className={classNames(classes.inputLabel)}
                  >
                    {intl.formatMessage({
                      defaultMessage: "เงื่อนไขการชำระเงิน",
                      description: "label"
                    })}
                  </MyTypography>
                  <div className={classes.inputField}>
                    <div className={classes.paymentTerms}>
                      <MyTypography variant="body3">
                        {customerData?.contract?.paymentTermDescriptionTh}
                      </MyTypography>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <MyTypography
                    variant="subtitle3"
                    className={classes.inputLabel}
                  >
                    {intl.formatMessage({
                      defaultMessage: "วันที่ออกใบสั่งซื้อ",
                      description: "label"
                    })}
                    <span className={classes.required}>*</span>
                  </MyTypography>
                  <div className={classes.inputField}>
                    <DatePicker
                      name={"orderDate"}
                      id={"orderDate"}
                      value={formik.values.orderDate}
                      onChange={handlePODate}
                      disabledInitialRendering
                      noBlock
                      error={
                        !!(formik.errors.orderDate && formik.touched.orderDate)
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <MyTypography
                    variant="subtitle3"
                    className={classNames(classes.inputLabel)}
                  >
                    {intl.formatMessage({
                      defaultMessage: "วันที่ต้องการสินค้า",
                      description: "label"
                    })}
                    <span className={classes.required}>*</span>
                  </MyTypography>
                  <div
                    className={classNames(
                      classes.submitForm,
                      classes.flexItemTop
                    )}
                  >
                    <div className={classes.inputField}>
                      <DatePicker
                        name={"requestDeliveryDate"}
                        id={"requestDeliveryDate"}
                        value={formik.values.requestDeliveryDate}
                        onChange={handleChangeDatepicker}
                        disabledInitialRendering
                        noBlock
                        error={
                          formik.errors.requestDeliveryDate &&
                          formik.touched.requestDeliveryDate
                        }
                      />
                      <div className={classes.textError}>
                        {formik.errors.requestDeliveryDate &&
                          formik.touched.requestDeliveryDate &&
                          formik.errors.requestDeliveryDate !== "Required" &&
                          formik.errors.requestDeliveryDate}
                      </div>
                    </div>
                    <Button
                      id={"applyAllButton"}
                      variant={"contained"}
                      type={"submit"}
                      className={classNames(classes.buttonApply, "defaultB")}
                    >
                      {intl.formatMessage({
                        defaultMessage: "Apply all",
                        description: "button label"
                      })}
                    </Button>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} md={12}>
                  {additionalInfoRender.map(
                    (infoRender: IAdditionalInfoRender) => (
                      <CountTextField
                        key={infoRender.id}
                        maxLength={250}
                        title={
                          <div className={classes.titleTextArea}>
                            {infoRender.icon}
                            <MyTypography
                              variant="body3"
                              className={classes.subTitleTextArea}
                            >
                              {infoRender.label}
                            </MyTypography>
                          </div>
                        }
                        name={infoRender.name}
                        id={infoRender.name}
                        placeHolder={infoRender.placeholder}
                        onChange={e =>
                          formik.setFieldValue(infoRender.name, e.target.value)
                        }
                        value={formik.values.internalCommentsToLogistic}
                        className={classes.customTextbox}
                        data-testid={infoRender.name}
                      />
                    )
                  )}
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.wrapInfoMore}>
              <Shipping address={customerData?.customerInfo?.addresses} />
            </div>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
});

export default CustomerData;
